
import Nav from "@/Components/Layout/Nav.vue";
import { useStore } from "@/stores/main";
import { computed, defineComponent, ref } from "vue";
import TextButton from "@/Components/Buttons/TextButton.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiMenu } from "@mdi/js";
import Messages from "@/Components/General/Messages.vue";
import { usePage } from "@inertiajs/inertia-vue3";

export default defineComponent({
  components: { Nav, TextButton, SvgIcon, Messages },
  setup(props) {
    const store = useStore();
    store.setUpStore();

    const navClasses = computed(() => {
      return {
        closed: !navOpen.value,
      };
    });

    const layoutClasses = computed(() => {
      return {
        small: store.navIsSmall,
      };
    });

    const navOpen = ref(false);

    return {
      navOpen,
      navClasses,
      navIsSmall: computed(() => store.navIsSmall),
      layoutClasses,
      menuIcon: mdiMenu,
    };
  },
});
